import getCurrentCamera from 'helpers/cameras/getCurrentCamera'
import { createSelector } from 'reselect'
import { cameraPropSelector } from 'selectors/components'
import path from 'ramda/src/path'
import pipe from 'ramda/src/pipe'
import split from 'ramda/src/split'
import ifElse from 'ramda/src/ifElse'

const parseAndRound = (num, accuracy) => parseFloat(num).toFixed(accuracy)

const computedDistance = (distance, ppfHover, accuracy) =>
  ppfHover.distance ? parseAndRound(ppfHover.distance, accuracy) : parseAndRound(distance, accuracy)

const accuracySelector = key => createSelector(
  path(['presentationValues', key, 'value']),
  pipe(split('.'), ifElse(arr => arr.length === 1, _ => 0, arr => arr[1].length > 2 ? 2 : arr[1].length))
)

const computedDistanceSelector = createSelector(
  cameraPropSelector('distance'),
  path(['ui', 'ppfHover']),
  accuracySelector('distance'),
  computedDistance
)

const computedPpf = (ppfHover, ppf, accuracy) =>
  ppfHover.ppf ? parseAndRound(ppfHover.ppf, accuracy) : parseAndRound(ppf,accuracy)

const mapStateToProps = state => ({
  distance: computedDistanceSelector(state),
  ppf: createSelector(
    path(['ui', 'ppfHover']),
    cameraPropSelector('ppf'),
    accuracySelector('ppf'),
    computedPpf
  )(state),
  currentCamera: getCurrentCamera(state.cameras),
  ppfNightMode: cameraPropSelector('ppfNightMode')(state),
  isImperial: state.ui.isImperial
})

export default mapStateToProps



// WEBPACK FOOTER //
// ./src/components/PpfPreview/selectors.js